<script setup>
import { ref, watch, useAttrs } from 'vue';
import { debounce, Notify } from 'quasar';
import { useClipboard } from '@vueuse/core';

const attrs = useAttrs();
const source = ref(attrs.text);
const { text, copy, copied, isSupported } = useClipboard({ source });

const menu = ref(false);
const menuOver = ref(false);
const listOver = ref(false);

const debounceFunc = debounce(checkMenu, 10);

function checkMenu() {
  if (menuOver.value || listOver.value) {
    menu.value = true;
  } else {
    menu.value = false;
  }
}
watch([menuOver, listOver], () => {
  debounceFunc();
});

function copying(v) {
  source.value = v;
  copy();
  Notify.create({
    message: 'Text Copied!',
    classes: 'bg-green px-4',
  });
}
</script>

<template>
  <div
    @mouseover="menuOver = true"
    @mouseout="menuOver = false"
    class="text-primary"
  >
    View
    <q-menu v-model="menu" persistent auto-close>
      <q-list
        style="min-width: 100px"
        dense
        @mouseover.native="listOver = true"
        @mouseout.native="listOver = false"
        separator
      >
        <q-item class="p-5 relative" v-for="(item, index) in $attrs.data">
          <div class="flex flex-col gap-2">
            <div>
              {{ $attrs.field === 'collectionFrom' ? 'Pickup' : 'Delivery' }}
              {{ ' ' + (index + 1) }}
            </div>
            <div class="font-semibold">
              <q-icon name="event" /> {{ item.date }}
            </div>
            <div class="font-semibold">
              <q-icon name="person" /> {{ item.client }}
            </div>
            <q-btn
              @click="copying(item.client)"
              flat
              class="cursor-pointer absolute top-0 right-0"
              icon="content_copy"
            />
          </div>
        </q-item>
      </q-list>
    </q-menu>
  </div>
</template>
